import { SET_AVG_DEMAND_EVENT, SET_BALANCING, SET_QUALITY, SET_OFFSHORE_BALANCING, SET_FUEL_CONSUMPTION } from './actionType'

export const setAVGDemandEventToState = (payload) => ({
  type: SET_AVG_DEMAND_EVENT,
  payload
})
export const setBalancingToState = (payload) => ({
  type: SET_BALANCING,
  payload
})
export const setQualityToState = (payload) => ({
  type: SET_QUALITY,
  payload
})
export const setOffshoreBalancingToState = (payload) => ({
  type: SET_OFFSHORE_BALANCING,
  payload
})
export const setFuelConsumptionToState = (payload) => ({
  type: SET_FUEL_CONSUMPTION,
  payload
})

